import React from "react";
import { FormGridColumnTypes } from "../../types/FormGrids";
import { BulkRadioButtons, BulkCheckbox } from "./FormGridComponents";
export function TableBulkAction(_a) {
    var headings = _a.headings, form = _a.form;
    return (React.createElement("tr", { className: "table__bulk-action" }, (form === null || form === void 0 ? void 0 : form.name) &&
        headings.map(function (heading, i) {
            var _a, _b, _c;
            if (i === 0 && form.bulkActionLabel) {
                return (React.createElement("td", { key: i },
                    React.createElement("span", { className: "font-weight-bold" }, form.bulkActionLabel)));
            }
            if (!((_a = heading.formComponent) === null || _a === void 0 ? void 0 : _a.bulkAction)) {
                return React.createElement("td", { key: i });
            }
            return (React.createElement("td", { key: i },
                ((_b = heading.formComponent) === null || _b === void 0 ? void 0 : _b.type) === FormGridColumnTypes.Radio && (React.createElement(BulkRadioButtons, { name: form === null || form === void 0 ? void 0 : form.name, formComponent: heading.formComponent })),
                ((_c = heading.formComponent) === null || _c === void 0 ? void 0 : _c.type) === FormGridColumnTypes.Checkbox && (React.createElement(BulkCheckbox, { name: form.name, formComponent: heading.formComponent }))));
        })));
}
